import Request from './request';

export default class CardService {
	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return this._instance = new CardService();
	}

	checkIfCard() {
		return Request.instance().get('/console/v1/card/check');
	}

	createCard(card) {
		return Request.instance().post('/console/v1/card/create', card);
	}

	createAddress(address) {
		return Request.instance().post('/console/v1/address/create', address);
	}

	getCardsList() {
		return Request.instance().get('/console/v1/card/list');
	}

	getAddressesList() {
		return Request.instance().get('/console/v1/address/list');
	}

	makeDefaultCard(id) {
		return Request.instance().post('/console/v1/card/default/' + id);
	}

	makeDefaultAddress(id) {
		return Request.instance().post('/console/v1/address/default/' + id);
	}

	createCardAndAddress(payload) {
		return Request.instance().post('/console/v1/billing/setup/bonus', payload);
	}
}